export default {"src":"/_next/static/media/cloud-functions.ce6d6932.svg","height":512,"width":640,"blurWidth":0,"blurHeight":0};